import { render, staticRenderFns } from "./HeaderEnrolment.vue?vue&type=template&id=20502cd1&"
import script from "./HeaderEnrolment.vue?vue&type=script&lang=js&"
export * from "./HeaderEnrolment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports